import React, { useEffect, useState } from 'react';
import { mockFeed } from '../lib/mocks';
import { FeedUpdate } from '../lib/types';

export const FeedComponent = () => {
    const [feed, setFeed] = useState<FeedUpdate | []>([]);
    const [loading, setLoading] = useState<boolean>(true);

    const fetchData = async () => {
        fetch('https://rubeserver.cloud24x7.net/feed')
            .then(result => result.json())
            .then(result => setFeed(result))
            .finally(() => setLoading(false));
    };

    const getDatestamp = (timestamp: number) => {
        var datetime = new Date(timestamp);
        return datetime.toLocaleTimeString();
    }

    useEffect(() => {
        const interval = setInterval(() => {
            fetchData();
        }, 500);
        return () => clearInterval(interval);
    }, []);

    const feedDisplay = () => feed?.map((feedMessage) => {
        return (
            <tr key={feedMessage?.timestamp} className="message">
                <td>{getDatestamp(feedMessage?.timestamp)}</td> <td>{feedMessage?.message}</td>
            </tr>
        )
    });

    return (
        <div>
            {loading ? (
                <div className="loading-message">
                    Loading!
                </div>
            ) : (
                <table>
                    <col className="column-1" />
                    <col className="column-2" />
                        <thead>
                            <tr>
                                <th>Time</th> <th>Message</th>
                            </tr>
                        </thead>
                        <tbody key={feed ? feed[0]?.timestamp : 0} >
                            {feedDisplay()}
                        </tbody>
                    </table>
                )
            }
        </div>
    );
}
